/*
 * vb-analytics.js
 * Eventos de analytics do storefront para o dataLayer (GTM -> GA4).
 * Fase 3 do guia: DEV/vibrolandia-docs/analytics-implementation.md
 *
 * Cobre o evento `search` (via Searchanise, que substitui a pesquisa nativa
 * da Shopify, logo o `search_submitted` nativo NAO dispara).
 *
 * NOTA: o mecanismo e o shape do evento do Searchanise nao estao 100%
 * confirmados (a doc menciona jQuery). Este codigo liga-se por addEventListener
 * nativo E por jQuery (se existir), com dedupe para nao disparar a dobrar, e
 * extrai os campos de varios sitios possiveis. Para ver o evento real, ativar
 * o modo debug:  localStorage.setItem('vb_analytics_debug', '1')
 * e fazer uma pesquisa: o evento bruto aparece na consola.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var DEBUG = false;
  try {
    DEBUG = window.localStorage.getItem('vb_analytics_debug') === '1';
  } catch (e) {}

  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[vb-analytics]'].concat([].slice.call(arguments)));
    }
  }

  // --- helpers de extracao defensiva -------------------------------------

  // Procura uma chave em varios candidatos de objecto, devolve o 1o valor != null
  function pick(obj, keys) {
    if (!obj) return undefined;
    for (var i = 0; i < keys.length; i++) {
      if (obj[keys[i]] != null) return obj[keys[i]];
    }
    return undefined;
  }

  // O Searchanise pode entregar o "detail" em sitios diferentes consoante o
  // mecanismo: e.detail (CustomEvent nativo) ou 2o argumento (evento jQuery).
  function extractDetail(eventArg, secondArg) {
    if (secondArg && typeof secondArg === 'object') return secondArg;
    if (eventArg && eventArg.detail) return eventArg.detail;
    if (eventArg && (eventArg.params || eventArg.data || eventArg.widgetType)) return eventArg;
    return {};
  }

  // --- handler de pesquisa ------------------------------------------------

  var lastSig = '';
  var lastTime = 0;

  function handleSearch(eventArg, secondArg) {
    var detail = extractDetail(eventArg, secondArg);
    log('Searchanise event bruto:', eventArg, secondArg, '-> detail:', detail);

    // So a pesquisa "a serio" (pagina de resultados), nao o autocomplete.
    var widgetType = pick(detail, ['widgetType', 'widget_type', 'type']);
    if (widgetType && String(widgetType).toLowerCase().indexOf('result') === -1) {
      log('ignorado (widgetType =', widgetType, ')');
      return;
    }

    var params = pick(detail, ['params', 'request', 'query']) || {};
    var data = pick(detail, ['data', 'response', 'result']) || {};

    var term = pick(params, ['q', 'query', 'text', 'searchText']);
    if (!term && typeof params === 'string') term = params;
    if (!term) {
      log('sem termo, ignorado');
      return;
    }
    term = String(term).trim();
    if (!term) return;

    var count = pick(data, ['totalProducts', 'total', 'totalItems', 'found', 'totalHits']);

    // Dedupe: ignora a mesma pesquisa repetida em < 1s (resize, re-render, etc.)
    var sig = term + '|' + (count != null ? count : '');
    var now = Date.now();
    if (sig === lastSig && now - lastTime < 1000) {
      log('duplicado, ignorado:', sig);
      return;
    }
    lastSig = sig;
    lastTime = now;

    var payload = { event: 'search', search_term: term };
    if (count != null) payload.search_results_count = Number(count);

    window.dataLayer.push(payload);
    log('search ->', payload);
  }

  // --- ligacao aos eventos do Searchanise --------------------------------
  // Liga pelos dois mecanismos; o dedupe acima evita duplicacao se ambos
  // dispararem para o mesmo evento.

  var EVENT_NAME = 'Searchanise.DataRequestEnd';

  document.addEventListener(EVENT_NAME, function (e) {
    handleSearch(e);
  });

  function bindJQuery() {
    var jq = window.jQuery || window.$;
    if (jq && jq.fn) {
      jq(document).on(EVENT_NAME, function (e, secondArg) {
        handleSearch(e, secondArg);
      });
      log('ligado via jQuery');
      return true;
    }
    return false;
  }

  if (!bindJQuery()) {
    // jQuery pode carregar depois (app injecta tarde). Tenta algumas vezes.
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (bindJQuery() || tries > 20) clearInterval(iv);
    }, 500);
  }

  log('vb-analytics inicializado');
})();
